import {
  Component,
  h,
  Prop,
  Element,
  Event,
  EventEmitter,
  Host,
} from '@stencil/core';

@Component({
  tag: 'signet-menu-item',
})
export class SignetMenuItem {
  @Element() $el: HTMLElement;

  @Prop({ mutable: true }) preventClose = false;

  @Event() closeMenu: EventEmitter;

  clickHandler() {
    if (!this.preventClose) this.closeMenu.emit();
  }

  render() {
    return (
      <Host
        role="listitem"
        onClick={() => this.clickHandler()}
        class="menu-item"
      >
        <slot />
      </Host>
    );
  }
}
